
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alertAI-education",
      function () {
        return require("private-next-pages/alertAI-education/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alertAI-education"])
      });
    }
  